import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import * as utils from './_utils';

export default ({ start, end, value, onChange }) => {
  const startUnits = utils.getHumanReadableDurationFull(start);
  const endUnits = utils.getHumanReadableDurationFull(end);

  const renderHandle = props => {
    return (
      <div
        className={`slider-handle ${props.className}`}
        style={{
          left: `${props.offset}%`,
        }}
      >
        <span className="slider-handle-tooltip">
          {utils.getHumanReadableDuration(value)}
        </span>
        {utils.getColonSeparatedDuration(value)}
      </div>
    );
  };

  return (
    <React.Fragment>
      <span className="delay-slider-title">Delay By: </span>
      <div
        className="delay-slider"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <span className="delay-slider-label start">{startUnits}</span>
        <Slider
          className="delay-slider-element"
          min={start}
          max={end}
          step={5}
          value={value}
          onChange={(val)=>{
          if (val > 1) {
            onChange(val - 1);
          } else {
            onChange(1);
          }
        }}
          handle={renderHandle}
        />
        <span className="delay-slider-label end">{endUnits}</span>
      </div>
    </React.Fragment>
  );
};